import { FilterProp, FilterPropForExtendedSubjectTree } from 'frontend/types'
import { filterSchoolSubjectClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import { activeOptionLabel } from 'frontend/utils/helpers'
import { SearchParams } from 'backend/services/types/urApiService.types'
import ExtendedFilterDropdown from './ExtendedFilterDropdown/ExtendedFilterDropdown'

type Props = {
  subjectTreeExtended: FilterPropForExtendedSubjectTree[]
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
}

const KnowledgeAreaExtended = ({
  subjectTreeExtended,
  searchParams,
  updateSearch,
}: Props) => {
  const { subject_tree: subjectTreeParams } = searchParams

  const mainSubjects = subjectTreeExtended.flatMap(subject => {
    return subject.mainSubject
  })

  const subSubjects = subjectTreeExtended.flatMap(
    subject => subject.subSubjects,
  )

  const activeLabels = activeOptionLabel(
    [...mainSubjects, ...subSubjects],
    subjectTreeParams || '',
    true,
  )

  const handleOptionSelect = (
    option: FilterProp,
    optionsToRemove?: FilterProp[],
  ) => {
    const isSelected = activeLabels.includes(option.label)

    if (!isSelected) filterSchoolSubjectClick(option.value)

    updateSearch({
      subject_tree: [
        option.value,
        ...(optionsToRemove?.map(opt => opt.value) ?? []),
      ],
    })
  }

  return (
    <ExtendedFilterDropdown
      activeLabels={activeLabels}
      label="Kunskapsområde"
      onOptionSelect={handleOptionSelect}
      options={subjectTreeExtended}
    />
  )
}

export default KnowledgeAreaExtended
